import { useEffect, useRef } from 'react'
import { Route } from 'react-router-dom'

import { useSafeHtml } from '@/components/organisms/post/HtmlRenderer/useSafeHtml'
import { individualShowHtmlFormRelay } from '@/core/individual'

import { NotFoundWeb } from '../../Errors/NotFoundWeb'

export type InputParam = { name: string; value: string }
export type State = {
  action: string
  method: string
  inputs: InputParam[]
  isValidAction: boolean
  clientId: string | null
  clientToken: string | null
  verified: boolean | undefined
}

export type Actions = {
  verifyToken: ({
    clientId,
    token,
  }: {
    clientId: string
    token: string
  }) => Promise<void>
}

// クエリから action と inputs(JSON) を受け取り、自動でPOST送信する
export const HtmlFormRelayTemplate = ({
  state,
  actions,
}: {
  state: State
  actions: Actions
}) => {
  const formRef = useRef<HTMLFormElement>(null)
  const inputs = state.inputs
  const { formHtml, isValidAction } = {
    formHtml: `<form action="${state.action}" method="${state.method}">${inputs
      .map(
        inp =>
          `<input type="hidden" name="${inp.name}" value="${String(
            inp.value
          ).replace(/"/g, '&quot;')}" />`
      )
      .join('')}<button type="submit">submit</button></form>`,
    isValidAction: state.isValidAction,
  }
  const safeCheck = useSafeHtml({ text: formHtml })

  useEffect(() => {
    // ワンタイムトークンの検証は画面表示時の初回のみ
    // トークンが付与されずにアクセスされた場合も検証スタータス更新を行う
    actions
      .verifyToken({
        clientId: state.clientId ?? '',
        token: state.clientToken ?? '',
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    if (!state.action || !isValidAction || !formRef.current || !state.verified)
      return
    formRef.current.submit()
  }, [state.verified, state.action, isValidAction])

  if (
    !individualShowHtmlFormRelay() ||
    safeCheck !== 'safe' ||
    !isValidAction ||
    state.verified === false
  ) {
    return <Route path="*" render={() => <NotFoundWeb />} />
  }

  return (
    <form ref={formRef} action={state.action} method={state.method}>
      {inputs.map((inp, idx) => (
        <input
          key={`${inp.name}-${idx}`}
          type="hidden"
          name={inp.name}
          value={inp.value}
        />
      ))}
    </form>
  )
}
